// extracted by mini-css-extract-plugin
export default {"leftside-list":"UserDrawer_leftside-list__xfzl7","drawer-border":"UserDrawer_drawer-border__gy5fj"};